import React, { forwardRef, useImperativeHandle, useState } from 'react';
import _ from 'lodash';

export default forwardRef((props, ref) => {
  const [data] = useState(props.api.getDisplayedRowAtIndex(props.rowIndex).data);

  useImperativeHandle(ref, () => {
    return {
      getReactContainerClasses() {
        return ['custom-tooltip'];
      },
    };
  });

  return (
    <div
      className="custom-tooltip"
      style={{ backgroundColor: props.color || 'white', width: '400px', overflowX: 'auto', maxHeight: '300px' }}
    >
      <p>
        <span>Action Types: </span> {(_.get(data, 'actionTypes') ?? []).map((a) => a).join(', ')}
      </p>
      <p>
        <span>Email List: </span> {(_.get(data, 'emailAddressList') ?? []).map((a) => a).join(', ')}
      </p>
    </div>
  );
});
